<template>
  <div :class="display">
    <ul>
      <li class="tabItem" v-for="item in list" :key="item.index" @click="clickHandler(item)">
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: { type: Array, required: true },
    display: { type: String, default: 'TabButton' }
  },
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  name: 'TabButton',
  methods: {
    clickHandler (item) {
      this.$emit('click', item)
    }
  },
  components: {
  }
}
</script>

<style scoped>
.TabButton {
  display: flex;
  width: 100%;
  height: 100%;
}
.TabButton ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  list-style: none;
}
.TabButton .tabItem {
  height: 100%;
  cursor: pointer;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: var(--text-base);
  background-color: var(--bg-white);
  border-left: 1px solid var(--line-base);
  border-top: 1px solid var(--line-base);
  border-bottom: 1px solid var(--line-base);
}
.TabButton .tabItem:last-child {
  border-right: 1px solid var(--line-base);
}
.TabButton .tabItem:hover {
  background-color: var(--deactive);
  color: var(--bg-white);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TabButton.vue